import { CountryModel } from '@/modules/shared/types/country'

/**
 * Państwa szybkiego wyboru przychodzą z dwóch źródeł o różnym kształcie: GET
 * konfiguracji delegacji zwraca 4 pola, a lista państw w selektorze dodatkowo
 * `alias`, `currency` i `oftenUsed`. Strona porównuje stan z odpowiedzią
 * serwera po `JSON.stringify`, więc bez sprowadzenia obu do jednego kształtu
 * (i tej samej kolejności kluczy) formularz zostaje "brudny" po zapisie.
 */
export const toPriorityCountry = (country: CountryModel): CountryModel => ({
  id: country.id,
  code: country.code,
  name: country.name,
  nationId: country.nationId,
})

export const toPriorityCountries = (
  countries?: CountryModel[] | null,
): CountryModel[] => (countries ?? []).map(toPriorityCountry)
